"use client";

import Footer from "@/components/layout/Footer";
import Header from "@/components/layout/Header";
import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import { Suspense } from "react";

const awards = [
  // {
  //   id: 1,
  //   name: "Benin Community Association",
  //   title: "/assets/landing/co-award/BCA.jpeg",
  // },
  {
    id: 2,
    name: "Healthcare Professional Leadership and Development",
    title: "/assets/landing/co-award/HPLP.jpeg",
  },
  {
    id: 3,
    name: "Kaduna Customer Service School",
    title: "/assets/landing/co-award/KCSS.jpeg",
  },
  {
    id: 4,
    name: "Lace Resturant and Confectionaries",
    title: "/assets/landing/co-award/LRC.jpeg",
  },
  {
    id: 5,
    name: "Menopausal Community Support Initiative",
    title: "/assets/landing/co-award/MCSI.jpeg",
  },
  {
    id: 6,
    name: "Minerva Hub",
    title: "/assets/landing/co-award/MH.jpeg",
  },
  {
    id: 7,
    name: "Magjohns Nigeria Limited",
    title: "/assets/landing/co-award/MNL.jpeg",
  },
  {
    id: 8,
    name: "National Association Of Social Workers Benue State Chapter",
    title: "/assets/landing/co-award/NASOW.jpeg",
  },
  {
    id: 9,
    name: "Police Community Relations Committee",
    title: "/assets/landing/co-award/PCRC.jpeg",
  },
  {
    id: 10,
    name: "Playless Booking",
    title: "/assets/landing/co-award/playless-booking.jpeg",
  },
  {
    id: 11,
    name: "Society of Disaster Management Volunteers Initiative",
    title: "/assets/landing/co-award/SDMVI.jpeg",
  },
  {
    id: 12,
    name: "UNIBEN Social Work Alumni Set",
    title: "/assets/landing/co-award/USWAS.jpeg",
  },
  {
    id: 13,
    name: "West Africa Association Of Small Business Operators",
    title: "/assets/landing/co-award/WASSBO.jpeg",
  },
  {
    id: 14,
    name: "Zinovi Educational Foundation",
    title: "/assets/landing/co-award/ZEF.jpeg",
  },
];

function AwardGalleryContent() {
  const [displayedText, setDisplayedText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const fullText = " La Plage Meta Verse Corporate Award";

  useEffect(() => {
    let currentIndex = 0;
    const timer = setInterval(() => {
      if (currentIndex <= fullText.length) {
        setDisplayedText(fullText.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(timer);
      }
    }, 50);

    return () => clearInterval(timer);
  }, []);

  const filteredAwards = awards.filter((award) =>
    award.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <main className="bg-white">
      <Header />
      <section className="bg-[#21205A] text-white min-h-[60vh] flex items-center justify-center px-4">
        <div className="mx-auto max-w-3xl text-center">
          <h1
            className="mb-6 text-4xl font-light tracking-tight text-foreground md:text-6xl lg:text-7xl"
            style={{
              backgroundImage: "linear-gradient(90deg, #EFAE33, #B97BFF)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              display: "inline-block",
            }}
          >
            {displayedText}
            <span className="animate-pulse">|</span>
          </h1>
          <p className="text-lg leading-relaxed text-muted-foreground md:text-xl">
            The La Plage Meta Verse Corporate Award recognises organisations for
            exceptional leadership, innovation, and impactful contribution to
            professional development and global excellence.
          </p>
        </div>
      </section>
      <section className="w-full px-4 py-20">
        <div className="mx-auto max-w-7xl">
          <div className="mb-8">
            <div className="relative">
              <Search className="absolute left-4 top-1/2 h-5 w-5 -translate-y-1/2 text-muted-foreground" />
              <input
                type="text"
                placeholder="Search awards by name..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full rounded-lg border border-muted-foreground/20 bg-white py-3 pl-12 pr-4 text-foreground placeholder-muted-foreground focus:outline-none focus:ring focus:ring-[#21205A]"
              />
            </div>
          </div>

          <div className=" grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8">
            {filteredAwards.length > 0 ? (
              filteredAwards.map((award) => (
                <div
                  key={award.id}
                  className=" bg-[#F5F5F5] group relative overflow-hidden rounded-lg  shadow-sm transition-all duration-300 hover:shadow-2xl"
                >
                  <div className="aspect-video bg-gradient-to-br from-muted to-muted-foreground/20 flex items-center justify-center">
                    <img
                      src={award.title || "/placeholder.svg"}
                      alt={award.name}
                      className="h-auto w-auto  transition-transform duration-300 group-hover:scale-105"
                    />
                  </div>
                  <div className="p-4">
                    <h3 className="text-sm text-foreground ">{award.name}</h3>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-span-full text-center py-12">
                <p className="text-muted-foreground">
                  No awards found matching "{searchQuery}". Try a different
                  search.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
      <Footer />
    </main>
  );
}

export default function AwardGallery() {
  return (
    <Suspense fallback={null}>
      <AwardGalleryContent />
    </Suspense>
  );
}
